// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27xZO","placeholdersHeader":"styles_placeholdersHeader__2yYXh","editorStyle":"styles_editorStyle__19TG6","placeholdersBox":"styles_placeholdersBox__1yOla"};